import React from 'react';
import { SelectedIdsProvider } from './providers/selectedIdsProvider';
import IntervalSetupList from '../../shared/ui/IntervalSetupList';
import RemoveInterval from './components/RemoveInterval';
import { DurationAndTimeProvider } from './providers/durationAndTimeProvider';
import DurationAndTimeSelection from './components/DurationAndTimeSelection';
import AddInterval from './components/AddInterval';

const ByIntervalSetupIntervals = ({
  fields,
  initialIds,
  durationAndTimeConfig,
  renderIntervalSettings,
  isIntervalDisabled,
}) => {
  return (
    <SelectedIdsProvider initialIds={initialIds}>
      <DurationAndTimeProvider config={durationAndTimeConfig}>
        <IntervalSetupList
          intervalFields={fields}
          renderRowStart={RemoveInterval}
          renderRowMiddle={DurationAndTimeSelection}
          renderRowEnd={renderIntervalSettings}
          rowType={IntervalSetupList.rowTypes.byInterval}
          isRowDisabled={isIntervalDisabled}
        />
        <AddInterval />
      </DurationAndTimeProvider>
    </SelectedIdsProvider>
  );
};

export default ByIntervalSetupIntervals;
